<template>
  <div class="pageDiv">
    <v-card class="no-login" v-if="!$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Sponsor Admin</span>
      </v-card-title>
      Must login to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Sponsor Admin</span>
      </v-card-title>
      
      <v-card-text style="margin: 7px 0">
        <div>
            <span class="label14">Select Year: </span>
            <select class="dropdown" v-model="year" @change="loadSponsors()">
              <option value="2025">2025</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
            </select>
        </div>
      </v-card-text>

      <div class="flex-container">
        <div class="side-card">
          <div style="display:inline-block;width:100%;margin: 5px 0;">
            <v-btn class="primary-btn" @click="newSponsor()">New Sponsor</v-btn>
            <v-btn class="primary-btn" @click="deleteSponsor()">Delete</v-btn>
          </div>

          <v-simple-table class="simple-table">
            <tr>
              <th>#</th>
              <th style="text-align:left;">Sponsor Name</th>
              <th width="80px">Type</th>
              <th width="80px">Priority</th>
            </tr>
            <tr v-for="(sponsor, index) in sponsors" :key="sponsor"
                @click="selectSponsor(sponsor, index)"
            >
              <td :class="{selected: selectedSponsor===index}">{{index+1}}</td>
              <td style="text-align:left;" :class="{selected: selectedSponsor===index}">{{sponsor.sponsorName}}</td>
              <td :class="{selected: selectedSponsor===index}">{{sponsor.sponsorType}}</td>
              <td :class="{selected: selectedSponsor===index}">{{sponsor.priority}}</td>
            </tr>
          </v-simple-table>
        </div>

        <div v-if="sponsor !== null" class="sponsor-card">
          <div style="display:inline-block;width:100%;height:20px">
             <v-btn :class="{btnDisabled: sponsor.isEdit===false}" class="primary-btn"
                   style="float:right" @click="saveSponsor()">Save</v-btn>
          </div>

          <v-card-text class="sponsor-item">
            <div style="width:60%;">
              <v-text-field label="Sponsor Name" v-model="sponsor.sponsorName" @change="sponsor.isEdit=true">
              </v-text-field>
            </div>

            <div>
              <span>Type: </span>
              <select class="dropdown" v-model="sponsor.sponsorType" @change="sponsor.isEdit=true">
                <option value="">Select Type</option>
                <option value="Platinum">Platinum</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
              </select>
              <br v-if="!$AuthSvc.isDesktop()">
              <br v-if="!$AuthSvc.isDesktop()">

              <span>Visible?: </span>
              <select class="dropdown" v-model="sponsor.visible"  @change="sponsor.isEdit=true">
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </select>
              <br v-if="!$AuthSvc.isDesktop()">
              <br v-if="!$AuthSvc.isDesktop()">

              <div style="width: 70px !important;display:inline-block;">
                <v-text-field label="Priority" v-model="sponsor.priority" @change="sponsor.isEdit=true">
                </v-text-field>
              </div>
              <br v-if="!$AuthSvc.isDesktop()">
              <br v-if="!$AuthSvc.isDesktop()">
            </div>

            <div>
              <v-text-field label="Photo Name" v-model="sponsor.photoName" @change="sponsor.isEdit=true">
              </v-text-field>
              <br v-if="!$AuthSvc.isDesktop()">
            </div>

            <div>
              <v-text-field label="Phone" v-model="sponsor.phone" @change="sponsor.isEdit=true">
              </v-text-field>
              <br v-if="!$AuthSvc.isDesktop()">
            </div>

            <div>
              <v-text-field label="Email" v-model="sponsor.email" @change="sponsor.isEdit=true">
              </v-text-field>
              <br v-if="!$AuthSvc.isDesktop()">
            </div>

            <div>
              <v-text-field label="Website URL" v-model="sponsor.website" @change="sponsor.isEdit=true">
              </v-text-field>
              <br v-if="!$AuthSvc.isDesktop()">
            </div>

            <div id="image-div-id">
              <div class="flex-container">
                <div>
                  <span class="label16">Choose image</span><br/>
                  <input id="choose-file-id" style="padding:5px 10px" type="file" @change="handleFileUpload( $event )"/>
                </div>
                <div>
                  <v-btn class="primary-btn" v-on:click="uploadSponsorImaged()">Upload</v-btn>
                </div>
              </div>

              <div :class="sponsor-img-div">
                <div class="loader" v-if="isBusy"></div>
                <img
                  :class="{scoreCardImg: 1===1, imagePlatinumDiv:sponsor.sponsorType==='Platinum',imageGoldDiv:sponsor.sponsorType==='Gold',imageSilverDiv:sponsor.sponsorType==='Silver'}"
                  :src="getFileName()" >
              </div>
            </div>
          </v-card-text>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      year: 2025,
      sponsors: [],
      sponsor: null,
      isBusy: false,
      file: null,
      selectedSponsor: null
    }),
    mounted: function() {
        var _this = this;
        _this.loadSponsors();
    },
    methods: {
      loadSponsors() {
        var _this = this;

        _this.axios.get('/admin/sponsors/visible/'+_this.year)
          .then(function (response) {
              _this.sponsors = new Array();

              var data = null;
              var i;

              for(i=0; i < response.data.length; i++) {
                if (response.data[i].sponsorType === 'Platinum') {
                  data = response.data[i];
                  data.isEdit = false;
                  _this.sponsors.push(data);
                }
              }

              for(i=0; i < response.data.length; i++) {
                if (response.data[i].sponsorType === 'Gold') {
                  data = response.data[i];
                  data.isEdit = false;
                  _this.sponsors.push(data);
                }
              }

              for(i=0; i < response.data.length; i++) {
                if (response.data[i].sponsorType === 'Silver') {
                  data = response.data[i];
                  data.isEdit = false;
                  _this.sponsors.push(data);
                }
              }
          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
      },
      selectSponsor(sponsor, idx) {
        this.selectedSponsor = idx;
        this.sponsor = sponsor;
        var elem = document.getElementById("image-div-id");
        if (elem !== null) {
          elem.src = this.getFileName();
        }
        document.getElementById("choose-file-id").value = "";
      },
      newSponsor() {
        this.sponsor = {
          sponsorId: 0,
          priority: 1,
          sponsorType: '',
          sponsorName: '',
          year: this.$AuthSvc.getYear(),
          photoName: '',
          visible: 'Y',
          isEdit: true
        };

        for (var i=0; i < this.sponsors.length; i++) {
          this.sponsors[i].isEdit = false;
        }

        this.sponsors.push(this.sponsor);
      },
      deleteSponsor() {
        var _this = this;

        swal({
          title: "Are you sure?",
          text: "Delete " + _this.sponsor.sponsorName + "? You cannot recover!",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
              _this.axios.delete('/admin/sponsors/'+ _this.sponsor.sponsorId)
              .then(function (response) {
                  console.log('REMOVED Tournament Successful ' + response.data);
                  _this.sponsor = null;
                  _this.loadSponsors();
              })
              .catch(function (error) {
                  swal("Problem", "Cannot remove sponsor because it has references.", "error");
                  console.log('ERROR: ' + error);
              });
          }
        });
      },
     saveSponsor() {
          var _this = this;
          _this.axios.post('/admin/sponsors', _this.sponsor)
            .then(function (data) {
                swal("Success", "Sponsor is saved successfully.", "info")
                 .then((willDelete) => {
                    var elem = document.getElementById("image-div-id");
                    if (elem !== null) {
                      elem.src = this.getFileName();
                    }
                    document.getElementById("choose-file-id").value = "";
                    _this.sponsor.isEdit = false;
                    _this.loadSponsors();

                 });
            })
            .catch(function (error) {
                console.log('ERROR: ' + error);
            });
      },
      handleFileUpload( event ){
        this.file = event.target.files[0];
        this.sponsor.isEdit = true;
      },
      uploadSponsorImaged() {
        var _this = this;

        _this.isBusy = true;

        let formData = new FormData();

        this.sponsor.photoName = this.file.name;
        formData.append('file', this.file);

        this.axios.post( '/admin/images/sponsors-ad/load/'+this.sponsor.photoName,
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function() {
          _this.isBusy = false;
          document.getElementById("choose-file-id").value = "";
          swal("Success", "Image uploaded successfully.", "info")
           .then((willDelete) => {
              console.log("UPD: " + willDelete);
           });
        })
        .catch(function(error){
          _this.isBusy = false;
          swal("Problem", "Unable to load image.", "error");
          console.log('FAILURE!! ' + error);
        });
      },
      getFileName() {
        return "/images/sponsors-ad/" + this.sponsor.photoName + "?" + new Date().getTime();
      }
    }
  }

</script>

<style scoped>

    .main-card {
      overflow-y: scroll;
    }

    th {
      height: 36px;
      background-color: #602e14;
      border: 1px solid aquamarine;
      box-shadow: 2px 2px 1px -1px #000;
      font-size: 16px;
      padding: 3px;
      color: #f8eee8;
    }

    td {
        height: 60px;
        font-size: 14px;
        font-weight: bold;
        color: #2a2b1e;
        box-shadow:-2px -2px 1px -1px #000;
        padding: 3px;
        text-align: center;
        vertical-align: middle;
    }

    .main-card {
        margin: 10px;
    }

    select {
      width: 120px;
      margin-right: 50px;
    }

    .sponsor-card {
      width: 100%;
      border: 1px solid;
      border-radius: 5px;
      padding: 10px;
      margin-top: 20px;
    }

    .sponsor-card > div {
      display: inline-block;
    }

    .sponsor-item > div {
      display: inline-block;
      margin-bottom: 7px;
      margin-right: 20px;
      width: 100% !important;
      height: 55px;
    }

    .sponsor-item > div > span {
      display: inline-block;
      margin-right: 10px;
      font-size: 14px;
      font-weight: bold;
    }

    .scoreCardImg {
      display: inline-block;
      width: 90%;
      object-fit: fill;
      border-radius: 15px;
      border: 3px solid navy;
      margin-top: 20px;
    }

    .imagePlatinumDiv {
       width: 90% !important;
    }

    .imageGoldDiv {
       width: 50% !important;
    }

    .imageSilverDiv {
       width: 50% !important;
    }

    .checkbox {
      display: inline-block;
      float: left;
      width: 20px;
      height: 20px;
    }

    .add-button {
      background-color: #1867c0 !important;
      border-color: #1867c0 !important;
      color: white !important;
      float: left;
      margin-bottom: 10px;
    }

    .save-button {
      background-color: #1867c0 !important;
      border-color: #1867c0 !important;
      color: white !important;
      float: right;
    }

    .tournament-card {
      background-color: #D6DADA !important;
      margin: 10px 0;
      padding: 12px;
    }

    .sponsor-item {
      display: inline-block;
      padding: 10px;
      height: auto;
      margin-bottom: 7px;
      vertical-align: top;
    }

    .simple-table {
      height: 430px;
      overflow-y: scroll;
    }

    .side-card {
      width: 100%;
      height: 500px;
      border: 1px solid;
      border-radius: 5px;
      padding: 10px;
    }


    .sponsor-img-div {
      padding: 10px;
      width: 100%;
    }


    @media (min-width: 768px) {
        .main-card {
            height: 1000px;
        }

        .flex-container {
            display: flex;
        }

        .flex-container > div {
            margin: 0 0 0 10px;
        }

        .submit-file-card {
          padding: 10px;
        }

        .simple-table {
          height: 760px;
        }

        .side-card {
          width: 40%;
          height: 800px;
          overflow-y: scroll;
        }

        .sponsor-card {
          width: 52%;
          height: 800px;
          overflow-y: scroll;
        }

        .sponsor-item {
          height: 220px;
        }

        .image-div {
          max-height: 350px;
          max-width: 700px;
        }

        .sponsor-img-div {
          height: 300px;
          width: auto;
        }
    }

    .selected {
      background-color: lightgrey;
    }

    .btnDisabled {
      background-color: lightgrey !important;
    }

    .primary-btn {
      margin-right: 12px;
    }
</style>